//// js/config.js
export const CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  LOGIN_URL: "login",
  VEHICLE_AVERAGE_AGE_GRAPH_URL: "vehicle-ages",
  STATUS_STACKED_BAR_GRAPH_URL: "vehicles_in_fleet",
  TRUCK_HEALTH_OVERVIEW_URL: "truck-health-overview",
  TRUCK_HEALTH_OVERVIEW_FILTERS: "truck-health-overview-filters",
  TRUCK_HEALTH_VEHICLE_FILTERS: "truck-health-vehicle-id",  
  VEHICLE_DETAILS_URL: "vehicle-health2",
  FAILURES_PREVENTED_URL: "failures-prevented",
  RECOMMENDATIONS_URL: "recommendations",
  VEHICLE_AI_RECOMMENDATIONS_URL: "vehicle-recommendations",
  TOP_FAILURES_PREDICTION_GRAPH_URL: "top-failures-prediction",
  DOWNTIME_NEXT_WEEK_PREDICTION_GRAPH_URL: "downtime-next-week-prediction",
  UNPLANNED_DOWNTIME_AVOIDED_URL: "unplanned-downtime-avoided",
  MAINTENANCE_COST_SAVED_URL: "maintenance-cost-saved",
  AVERAGE_MAINTENANCE_GRAPH_URL: "average-maintenance-cost",
  COMPLIANCES_GRAPH_URL: "compliances",
  LOGOUT_URL: "logout",
  LOGO_PATH: "img/logo.png",
  USER_AVATAR: "img/user_avatar.jpeg",
  VEHICLE_PREDICTED_RIOSK_DETAILS_URL: "vehicle-predicted-risk"
};